import { SyntheticEvent } from 'react'

import { PopinProps } from '../../components/Popin'
import ActionButton, { ActionButtonProps } from '../../components/ActionButton'

export const objectivesValidateModalTransformer = (
  t?: any,
  isValidateModalOpen?: boolean,
  handleClose?: (ev: SyntheticEvent) => void,
  keepOriginalButtonProps?: ActionButtonProps,
  generateButtonProps?: ActionButtonProps
): PopinProps => ({
  title: t('objectives_popin_title'),
  textsContent: (
    <p
      dangerouslySetInnerHTML={{ __html: t('objectives_popin_description') }}
    />
  ),
  buttonsContent: (
    <>
      {keepOriginalButtonProps && <ActionButton {...keepOriginalButtonProps} />}
      {generateButtonProps && <ActionButton {...generateButtonProps} />}
    </>
  ),
  isOpen: isValidateModalOpen,
  handleClose,
  imageProps: {
    src: '/images/onboarding/target.png',
    alt: '',
    height: 342,
    width: 480,
  },
})
